import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { modifier, textAlignClassName, } from "../modifiers/index.js";
export const Level = ({ children, className, isMobile, left, right, ...props }) => {
    const _class = classNames("level", modifier({ isMobile }), className);
    return (_jsxs("div", { className: _class, ...props, children: [left && _jsx("div", { className: "level-left", children: left }), children, right && _jsx("div", { className: "level-right", children: right })] }));
};
export const LevelItem = ({ className, children, hasText, ...props }) => {
    const _class = classNames("level-item", textAlignClassName(hasText), className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
